import { Pipe, PipeTransform } from '@angular/core';
import { DateTime } from 'luxon';

@Pipe({
  name: 'utcToLocal'
})
export class UtcToLocal implements PipeTransform {

  constructor() { }

  public transform(value?: any): Date | number | string {
    if (value) {
      const zone = Intl.DateTimeFormat().resolvedOptions().timeZone;
      const local = DateTime.fromISO(value, {zone});
      const js = local.toJSDate();
      return js;
    } else {
      return '';
    }
  }
}
